import { FormattedMessage } from 'react-intl';
import { ContentBody } from '../../../components/atoms/ContentBody/ContentBody';
import { ScreenWrapper } from '../../../components/atoms/ScreenWrapper/ScreenWrapper';
import { Header } from '../../../components/organisms/Header/Header';
import { PageView } from '../../../models/analytics';
import { CustomScenario, ScenariosList } from '../../components/ScenariosList/ScenariosList';
import { H1 } from '../../../components/atoms/Heading/Heading';
import { Caption } from '../../../components/atoms/Text/Text';
import { DemoBankScenario } from '../../../models/demobankScenarios';
import { messages } from './messages';

export type DemobankScenarioPickerProps = {
  scenarios: DemoBankScenario[];
  onNoScenario: () => void;
  onClickScenario: (scenarioId: string) => void;
  onBack: () => void;
};

export const DemobankScenarioPicker = ({
  scenarios,
  onNoScenario,
  onClickScenario,
  onBack,
}: DemobankScenarioPickerProps) => {
  return (
    <ScreenWrapper>
      <Header onBack={onBack} pageView={PageView.DEMOBANK_SCENARIO_PICKER_SCREEN} />
      <ContentBody fullWidth>
        <Caption bold mb="xxsmall" color="secondary">
          <FormattedMessage {...messages.sandboxMode} />
        </Caption>
        <H1>
          <FormattedMessage {...messages.selectTestScenario} />
        </H1>
        <CustomScenario onClick={onNoScenario} />
        <ScenariosList scenarios={scenarios} onClick={onClickScenario} />
      </ContentBody>
    </ScreenWrapper>
  );
};
